<template>
  <el-form
    ref="form"
    label-width="120px"
    label-position="right"
    :inline="true"
    size="mini"
    class="search-form"
  >
    <el-row>
      <el-col v-for="c in config" :key="c.hash" :span="c.span">
        <ElementCreator :config="c" />
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <el-col :span="24" class="btns-row">
        <el-form-item>
          <el-button round size="mini" type="primary" @click="handleSearch">
            <i class="el-icon-search">&nbsp;&nbsp;</i>Search
          </el-button>
          <el-button
            v-if="exportShow"
            round
            size="mini"
            type="primary"
            plain
            @click="downloadResult"
          >
            <i class="el-icon-download">&nbsp;&nbsp;</i>export
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ElementCreator from './ElementCreator'
import { routeInfoPRDC, routeInfoCSR } from '../router'

export default {
  name: 'SearchInputs',
  components: {
    ElementCreator
  },
  created () {
    setTimeout(() => {
      if (this.$route.query.type === 'csr') {
        this.setDrafterType(3)
        this.setStatus(1)
      }

      this.initLoad()
    }, 400)
  },
  computed: {
    ...mapState('config', {
      config: 'inputs'
    }),
    ...mapState('search', {
      searchPage: 'searchPage'
    }),
    exportShow () {
      return this.searchPage !== 'Quotings' && this.searchPage !== 'Ocops'
    }
  },
  methods: {
    ...mapMutations({
      setDrafterType: 'search/setDrafterType',
      setStatus: 'search/setStatus'
    }),
    ...mapActions({
      search: 'search/search',
      downloadOrder: 'search/export',
      baseDowload: 'search/exportBaseInfo'
    }),
    downloadResult () {
      const routeName = this.$route.name
      if (routeName === routeInfoPRDC || routeName === routeInfoCSR) {
        this.baseDowload(routeName)
      } else {
        this.downloadOrder()
      }
    },
    async handleSearch () {
      this.bus.$emit('new-search')
      await this.search()
      // console.log("ready to emit data-refresh");
      this.bus.$emit('data-refresh')
    },
    initLoad () {
      if (this.searchPage !== 'Quotings' && this.searchPage !== 'Ocops') {
        this.handleSearch()
      }
    }
  },
  watch: {
    // 如果不是quoting或ocop页面，那进入后自动触发搜索操作.
    searchPage: function (newVal) {
      setTimeout(() => this.initLoad(), 400)
    }
  },
  inject: ['bus']
}
</script>

<style lang="scss" scoped>
.btns-row {
  justify-content: center;
}
.el-divider {
  margin: 6px 0;
  background-color: #e5e5f14b;
}
</style>
